/* eslint-disable no-restricted-properties, turbo/no-undeclared-env-vars */

// TODO REPO MIGRATE

import { createEnv } from "@t3-oss/env-nextjs"
import { authEnv } from "@ucr/auth/lib/authEnv"
import { baseEnv } from "@ucr/utils/environment/baseEnv"
import { createCIEnvValidationHandler } from "@ucr/utils/environment/envValidationHandler"
import { nextEnv } from "@ucr/utils/environment/nextEnv"
import { z } from "zod"

// TODO For now
import { securelyGetGitHash } from "../utils/secureGitCommitHash"

// All env variables that we expect are not available on CI - secrets for example are added through kubernetes to the docker container after ci is finished
const NOT_AVAILABLE_ON_CI = ["AUTH_SECRET"]

// No problem to keep server and client validation inside the same file (server variable names get shipped to client) as long as there is no sensitive information inside the env variable names https://env.t3.gg/docs/nextjs

export const ENVIRONMENT = createEnv({
  extends: [baseEnv(NOT_AVAILABLE_ON_CI), authEnv(NOT_AVAILABLE_ON_CI), nextEnv(NOT_AVAILABLE_ON_CI, false)],
  shared: {},
  server: {
    PORT: z.coerce.number(),

    // TODO REPO MIGRATE
    API_URL: z.string().url(),
    NEXTAUTH_SECRET: z.string(),
    NEXTAUTH_URL: z.string().url(),
    GOOGLE_CLIENT_ID: z.string(),
    GOOGLE_CLIENT_SECRET: z.string(),
    HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY: z.string(),

    // Deployment
    GIT_COMMIT_HASH: z.string(),
  },
  client: {
    NEXT_PUBLIC_API_URL: z.string().url(),

    // TODO REPO MIGRATE
    NEXT_PUBLIC_CDN_URL: z.string().url(),
    NEXT_PUBLIC_URL: z.string().url(),
    NEXT_PUBLIC_STRIPE_PUBLIC_KEY: z.string(),
    NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID: z.string().optional(),

    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().url(),
  },
  runtimeEnv: {
    // If new env variables are added and get an ESLINT error for turbo/... add them to the root turbo.json globalEnv array and restart ESLINT service of editor if error stays
    PORT: process.env.PORT,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,

    // TODO REPO MIGRATE
    // Client
    NEXT_PUBLIC_CDN_URL: process.env.NEXT_PUBLIC_CDN_URL,
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL,
    NEXT_PUBLIC_STRIPE_PUBLIC_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY,
    NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID: process.env.NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,

    // Server
    API_URL: process.env.API_URL,
    NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
    NEXTAUTH_URL: process.env.NEXTAUTH_URL,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY: process.env.HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY,
    // Deployment
    GIT_COMMIT_HASH: securelyGetGitHash(),
  },

  onValidationError: createCIEnvValidationHandler(NOT_AVAILABLE_ON_CI),
})
